import AOPOrderbookDashboardUseCase from "@domains/features/OrderBook/useCases/AOPOrderbookDashboardUseCase";
import AOPOrderbookSelfieLinkUse from "@domains/features/OrderBook/useCases/AOPOrderbookSelfiLinkUseCase";
import AOPOrderbookESignLinkUseCase from "@domains/features/OrderBook/useCases/AOPOrderbookESignLinkUseCase";
import AOPOrderbookGetKycUseCase from "@domains/features/OrderBook/useCases/AOPOrderbookGetKycUseCase";
import AOPOrderbookClientDetailsUseCase from "@domains/features/OrderBook/useCases/AOPOrderbookClientDetails";
import AOPOrderBookClientFilterUseCase from "@domains/features/OrderBook/useCases/AOPOrderBookClientFilterUseCase";
import AOPDownloadUseCase from "@domains/features/OrderBook/useCases/AOPDownloadUseCase";
import AOPVerificationLinkUseCase from "@domains/features/OrderBook/useCases/AOPVerificationLinkUseCase";
export default (function (repositories) {
    return {
        aopOrderBook: {
            aopOrderBookDashboard: new AOPOrderbookDashboardUseCase(repositories.aopOrderBook),
            aopOrderBookSelfieLink: new AOPOrderbookSelfieLinkUse(repositories.aopOrderBook),
            aopOrderBookESignLnk: new AOPOrderbookESignLinkUseCase(repositories.aopOrderBook),
            aopOrderBookGetKyc: new AOPOrderbookGetKycUseCase(repositories.aopOrderBook),
            aopOrderBookApplicationDetails: new AOPOrderbookClientDetailsUseCase(repositories.aopOrderBook),
            aopOrderBookClientFilter: new AOPOrderBookClientFilterUseCase(repositories.aopOrderBook),
            aopOrderBookDownload: new AOPDownloadUseCase(repositories.aopOrderBook),
            aopVerificationLink: new AOPVerificationLinkUseCase(repositories.aopOrderBook),
        },
    };
});
